import { useState } from "react";
import { getAddresses, TOKEN_DECIMALS, DEFAULT_NETWORK } from "../../../constants";
import { SvgIcon } from "@material-ui/core";
import { ReactComponent as Diamond } from "../../../assets/icons/diamond.svg";
import { useSelector } from "react-redux";
import { Link, Fade, Popper } from "@material-ui/core";
import { InjectedConnector } from "@web3-react/injected-connector";
import "./db-menu.scss";
import { IReduxState } from "../../../store/slices/state.interface";
import { getTokenUrl } from "../../../helpers";

const addTokenToWallet = (tokenSymbol: string, tokenAddress: string) => async () => {
    const tokenImage = getTokenUrl(tokenSymbol.toLowerCase());
    console.log(tokenImage);

    if (window.ethereum) {
        try {
            await window.ethereum.request({
                method: "wallet_watchAsset",
                params: {
                    type: "ERC20",
                    options: {
                        address: tokenAddress,
                        symbol: tokenSymbol,
                        decimals: TOKEN_DECIMALS,
                        image: tokenImage,
                    },
                },
            });
        } catch (error) {
            console.log(error);
        }
    }
};

const AVALANCHE_MAINNET_PARAMS = {
    chainId: "0xA86A",
    chainName: "Avalanche Mainnet C-Chain",
    nativeCurrency: {
        name: "Avalanche",
        symbol: "AVAX",
        decimals: 18,
    },
    rpcUrls: ["https://api.avax.network/ext/bc/C/rpc"],
    blockExplorerUrls: ["https://snowtrace.io/"],
};
const injected = new InjectedConnector({
    supportedChainIds: [1, 3, 4, 5, 42, 43113, 43114],
});

const AVALANCHE_TESTNET_PARAMS = {
    chainId: "0xA869",
    chainName: "Avalanche Testnet C-Chain",
    nativeCurrency: {
        name: "Avalanche",
        symbol: "AVAX",
        decimals: 18,
    },
    rpcUrls: ["https://api.avax-test.network/ext/bc/C/rpc"],
    blockExplorerUrls: ["https://testnet.snowtrace.io/"],
};

const addAvalancheNetwork = () => {
    injected.getProvider().then(provider => {
        provider
            .request({
                method: "wallet_addEthereumChain",
                params: [AVALANCHE_MAINNET_PARAMS],
            })
            .catch((error: any) => {
                console.log(error);
            });
    });
};

function DbMenu() {
    const [anchorEl, setAnchorEl] = useState(null);
    const isEthereumAPIAvailable = window.ethereum;

    const networkID = useSelector<IReduxState, number>(state => {
        return (state.app && state.app.networkID) || DEFAULT_NETWORK;
    });

    const addresses = getAddresses(networkID);

    const SDB_ADDRESS = addresses.SDB_ADDRESS;
    const DB_ADDRESS = addresses.DB_ADDRESS;
    const DB_MIM_ADDRESS = addresses.DB_MIM_ADDRESS;
    const DB_AVAX_ADDRESS = addresses.DB_AVAX_ADDRESS;

    const handleClick = (event: any) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const open = Boolean(anchorEl);

    return (
        <div className="db-menu-root" onMouseEnter={e => handleClick(e)} onMouseLeave={e => handleClick(e)}>
            <div className="db-menu-btn">
                <p>DB</p>
            </div>

            <Popper className="db-menu-popper" open={open} anchorEl={anchorEl} transition>
                {({ TransitionProps }) => (
                    <Fade {...TransitionProps} timeout={200}>
                        <div className="tooltip">
                            <Link className="tooltip-item" href={`https://www.traderjoexyz.com/#/trade?inputCurrency=&outputCurrency=${DB_ADDRESS}`} target="_blank">
                                <p>Buy on Trader Joe</p>
                            </Link>

                            {isEthereumAPIAvailable && (
                                <div className="add-tokens">
                                    <div className="divider" />
                                    <p className="add-tokens-title">ADD TOKEN TO WALLET</p>
                                    <div className="divider" />
                                    <div className="tooltip-item" onClick={addTokenToWallet("DB", DB_ADDRESS)}>
                                        <p>
                                            (<SvgIcon component={Diamond} />,<SvgIcon component={Diamond} />) DB
                                        </p>
                                    </div>
                                    <div className="tooltip-item" onClick={addTokenToWallet("sDB", SDB_ADDRESS)}>
                                        <p>
                                            (<SvgIcon component={Diamond} />,<SvgIcon component={Diamond} />) sDB
                                        </p>
                                    </div>
                                    {/* <div className="tooltip-item" onClick={addTokenToWallet("DMLP", DB_MIM_ADDRESS)}>
                                        <p>(<SvgIcon component={Diamond} />,<SvgIcon component={Diamond} />) DB/MIM</p>
                                    </div>
                                    <div className="tooltip-item" onClick={addTokenToWallet("DALP", DB_AVAX_ADDRESS)}>
                                        <p>(💎,💎) DB/AVAX</p>
                                    </div> */}
                                    <div className="divider" />
                                    <p className="add-tokens-title">ADD CHAIN TO WALLET</p>
                                    <div className="divider" />
                                    <div className="tooltip-item" onClick={addAvalancheNetwork}>
                                        <p>AVAX C</p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </Fade>
                )}
            </Popper>
        </div>
    );
}

export default DbMenu;
